//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapGetters } from 'vuex';
import LoaderIcon from '~/assets/svg/ic-loader.svg?inline';
import HintEmail from '~/components/common/hintEmail';
import Phone from '~/components/common/phone';
import PrivacyPolicy from '~/components/common/privacyPolicy';
import addAnyFormFields from '~/utils/addAnyFormFields';
import urlencodeFormData from '~/utils/urlencodeFormData';
import EButton from '@/components/d0822/fields/button';

import BasketItem from './basketItem.vue';
import * as Sentry from '@sentry/vue';
import { getGRecaptchaScore } from '@/utils/grecaptcha';
import handleError from '@/utils/handleError';

import customerIoMixin from '@/mixins/customerIo.mixin';

export default {
  components: {
    EButton,
    ValidationObserver,
    ValidationProvider,
    HintEmail,
    Phone,
    PrivacyPolicy,
    BasketItem,
    LoaderIcon,
  },
  mixins: [customerIoMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    basketComputed: {
      type: Array,
      default: () => [],
    },
    basketGiftItems: {
      type: Array,
      default: () => [],
    },
    basketPromocodeItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fullHeight: false,

      loading: false,
      name: '',
      email: '',
      phone: '',
      promocode: '',
      promocodeError: '',
      promocodeLoading: false,
      promocodeSuccess: false,
      promocodeTotalPrice: 0,
      acceptedRules: true,
      couponReadonly: false,
    };
  },
  computed: {
    ...mapGetters('sale', ['basketType']),
    fullPrice() {
      const result = this.basketComputed.reduce(
        (acc, product) => acc + (product.free ? 0 : product.price.price),
        0,
      );

      this.debug({ name: 'comp fullPrice' }, '%O', result);
      return result;
    },
    totalPrice() {
      const result =
        this.promocodeTotalPrice === 0
          ? this.fullPrice
          : this.promocodeTotalPrice;

      this.debug({ name: 'comp totalPrice' }, '%O', result);
      return result;
    },
    priceInstallmentPlanPrice() {
      const result = this.$n((this.totalPrice / 12).toFixed(2), 'decimal');

      this.debug({ name: 'comp priceInstallmentPlanPrice' }, '%O', result);
      return result;
    },
    isEmailAvailable() {
      return !!this.$app.user?.email;
    },
    isNameAvailable() {
      return !!this.$app.user?.name;
    },
  },
  watch: {
    value() {
      this.debug({ name: 'watch value' });

      if (this.value.length && this.promocode.length) this.checkPromocode();

      this.clearPromocodeInfo();

      if (!this.value.length) {
        this.debug(
          { name: 'watch value' },
          'set store sale/setBasketDialog = %O',
          false,
        );

        this.$store.commit('sale/setBasketDialog', false);
      }
    },
    '$store.state.customerIo.userDataFromCio': {
      handler(dataFromCio) {
        if (!this.$app.user?.email && dataFromCio?.email) {
          this.email = dataFromCio.email;
        }
        if (!this.$app.user?.profile?.phone && dataFromCio?.phone) {
          this.phone = dataFromCio.phone;
        }
        if (!this.$app.user?.name && dataFromCio?.name) {
          this.name = dataFromCio.name;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this.debug({ name: 'mounted' });

    this.autoFillPromocode();

    if (this.promocode.length) {
      await this.checkPromocode();
    } else {
      this.debug({ name: 'mounted' }, 'emit clearFreeCourses');

      this.$emit('clearFreeCourses');
    }
    setTimeout(
      async () => await addAnyFormFields.call(this, { ref: this.$refs.form }),
      0,
    );
    const email = this.$app.user?.email;
    const phone = this.$app.user?.profile?.phone;
    const name = this.$app.user?.name;
    if (email) this.email = email.trim();
    if (phone) this.phone = phone.trim();
    if (name) this.name = name.trim();
  },
  methods: {
    clearPromocodeInfo() {
      this.debug({ name: 'clearPromocodeInfo' });

      this.promocodeTotalPrice = 0;
      this.promocodeSuccess = false;
      this.promocodeError = '';
    },
    processPromocode(promocode) {
      this.debug({ name: 'processPromocode' }, 'arg promocode = %s', promocode);

      if (!promocode) return;
      return promocode.trim().toLocaleLowerCase().replace(/ /g, '');
    },
    remove(item) {
      this.debug({ name: 'remove' }, 'arg item = %O', item);

      this.debug({ name: 'remove' }, 'emit input');
      this.$emit(
        'input',
        this.value.filter((basketItem) => item.id !== basketItem.id),
      );

      this.debug({ name: 'remove' }, 'emit removeFromBasketEvent');
      this.$emit('removeFromBasketEvent', item);
    },
    async onSubmit() {
      this.debug({ name: 'onSubmit' });

      if (this.loading) return;

      try {
        window?.$meter?.event({
          name: 'formSubmit',
          label: 'cartFormOnTheSalePage',
        });
      } catch (e) {
        console.error(e);
      }

      this.loading = true;

      const processedPromocode = this.processPromocode(this.promocode);

      const processedBasket = this.basketComputed.map((product) => {
        return {
          id: product.id,
          price: product.price.price,
          percent: product.price.percent,
          shortName: product.shortName,
          name: product.name,
          ...(Object.prototype.hasOwnProperty.call(product, 'free') && {
            free: product.free,
          }),
        };
      });

      const formData = new FormData(this.$refs.form.$el.querySelector('form'));
      if (processedPromocode) formData.append('promo_code', processedPromocode);
      formData.append('name', this.name);
      formData.append('phone', this.phone);
      formData.append('email', this.email);
      formData.append('checkbox', this.acceptedRules);
      formData.append('sale_id', this.$store.state.sale.sale.id);
      formData.append('products', JSON.stringify(processedBasket));

      const grecaptchaScore = await getGRecaptchaScore.bind(this)();
      formData.append('google_score', grecaptchaScore);

      if (processedBasket.length === 0) {
        Sentry.captureEvent({
          message: 'Sale basket is empty',
        });
      }

      this.debug(
        { name: 'onSubmit' },
        'POST formData = %O',
        urlencodeFormData(formData),
      );
      try {
        const response = await this.$axios({
          method: 'post',
          url: this.$app.config.current.saleUrl,
          data: urlencodeFormData(formData),
          headers: {
            'Content-Type': `application/x-www-form-urlencoded`,
          },
        });

        this.$refs.form?.reset();
        this.name = '';
        this.phone = '';
        this.email = '';

        //Обработка для двух возможных эндпоинтов получения контекста
        let context;
        //Версия с диспетчером в AWS
        if (response?.data?.executionArn) {
          context = response.data.executionArn.split(':').at(-1);
        }
        //Версия с старым диспетчером
        else {
          context = response.data.context;
        }

        if (context) {
          this.debug({ name: 'onSubmit' }, 'emit clearBasket');
          this.$emit('clearBasket');

          this.$router.push({
            path: '/sale/thankyou',
            ...(context && {
              query: {
                context,
                sale: this.$store.state.sale.sale.slug,
              },
            }),
          });
        }

        this.$gtm?.push({
          event: 'autoEvent',
          eventCategory: 'ds_lead',
          eventAction: 'from_cart',
        });

        if (response.status === 200) {
          try {
            window?.$meter?.event({
              name: 'formSuccess',
              label: 'cartFormOnTheSalePage',
            });
          } catch (e) {
            console.error(e);
          }
        }
      } catch (e) {
        handleError.bind(this)(e);
      }

      this.loading = false;
    },
    async checkPromocode() {
      this.debug({ name: 'checkPromocode' });

      this.promocodeLoading = true;
      let productIds = this.basketComputed.map((item) => {
        return item.id;
      });

      let params = {
        sourceId: this.$refs.sourceId.value,
        saleId: this.$store.state.sale.sale.id,
        productIds: productIds,
        couponCode: this.processPromocode(this.promocode),
        ignoreCouponApplication: true,
      };

      try {
        this.debug({ name: 'checkPromocode' }, 'GET params = %O', params);

        let response = await this.$axios.get(
          this.$app.config.current.promocodeUrl,
          { params },
        );
        if (response.status !== 200) {
          console.error(
            'CMS API promocode check error: ' + JSON.stringify(response),
          );
          return;
        }

        let data = response.data.data;

        if (data.status !== 'ok') {
          if (data.status === 'couponError') {
            let couponResultKeys = [];
            if (data.couponResult?.cannotBeUsed) {
              couponResultKeys = Object.keys(data.couponResult.cannotBeUsed);
            }
            this.promocodeError = this.$t(
              'sale.basketDialogContent.promocode.' +
                (couponResultKeys.length ? couponResultKeys[0] : 'exception'),
            );

            this.debug({ name: 'checkPromocode' }, 'emit clearFreeCourses');
            this.$emit('clearFreeCourses');
          } else {
            console.error('Unknown promocode error: ' + data.status);
            this.promocodeError = 'Promocode check error';
          }

          this.couponReadonly = false;

          return;
        }

        let responseIds = data.products.reduce(
          (acc, cur) => [...acc, cur.id],
          [],
        );

        this.debug(
          { name: 'checkPromocode' },
          'emit addPromocodeCourses = %O',
          responseIds,
        );
        this.$emit('addPromocodeCourses', responseIds);

        if (this.promocode.length) this.promocodeSuccess = true;

        this.promocodeTotalPrice = data.total;
      } catch (err) {
        console.error('Falied to check promocode: ' + err);
        return;
      } finally {
        this.promocodeLoading = false;
      }
    },
    autoFillPromocode() {
      this.debug({ name: 'autoFillPromocode' });

      this.autoFillPromoCodeForSales();
      this.autoFillPromoCodeByReferralProgramQueryParam();
      this.autoFillPromoCodeByQueryParam();
    },
    autoFillPromoCodeForSales() {
      this.debug({ name: 'autoFillPromoCodeForSales' });

      const list = this.$app.config.current.autoFillPromoCodeForSales;
      const slug = this.$store.state.sale.sale.slug;

      if (list && slug) {
        const currentSale = list.find((i) => i.saleSlug === slug);
        let currentCode = '';
        if (currentSale) {
          currentCode = currentSale.code;
          this.couponReadonly = currentSale.readonly || false;
        }

        if (!this.promocode) this.promocode = currentCode;
      }
    },
    autoFillPromoCodeByReferralProgramQueryParam() {
      this.debug({ name: 'autoFillPromoCodeByReferralProgramQueryParam' });

      let referralParam = this.$route.query['grsf'];
      if (referralParam) {
        referralParam = referralParam.split('-').pop();
        this.couponReadonly = true;
        if (!this.promocode) this.promocode = referralParam;
      }
    },
    autoFillPromoCodeByQueryParam() {
      this.debug({ name: 'autoFillPromoCodeByQueryParam' });

      const promoParam = this.$route.query['promo'];
      if (promoParam) {
        this.couponReadonly = false;
        if (!this.promocode) this.promocode = promoParam;
      }
    },
  },
};
